import { useState } from 'react';
import { FieldValues, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from './AuthComponents';
import ValidatoinForm, { ValidatoinFormConfig } from './ValidationForm';

/**
 * ログインフォームのコンポーネントです。
 * @returns   React.FunctionComponent
 */
const LoginForm: React.FC = () => {
        const methods = useForm();
        const getValues = methods.getValues;

        const [loginMessage, setLoginMessage] = useState('');

        const authContext = useAuthContext();
        const navigate = useNavigate();

        /**
         * 登録処理を行います。
         * @param data フォームのデータを指定します。
         * @param event フォームのイベントハンドラーを指定します。
         */
        const onSubmit: SubmitHandler<FieldValues> = (data, event) => {
            event?.preventDefault();
            console.log(data);

            const accountName = getValues('accountName');
            const password = getValues('password');

            const loginPromise = authContext.login(accountName, password);

            loginPromise
                .then((isLogin) => {
                    if (isLogin === true) {
                        navigate(authContext.from);
                    } else {
                        setLoginMessage('ログインに失敗しました。');
                    }
                })
                .catch((reson) => {
                    setLoginMessage('ログインに失敗しました。');
                    console.error(reson);
                });
        };

        const fields = [
            {
                name: 'accountName',
                label: 'アカウント名',
                type: 'text',
                rules: {
                    required: '必須項目です。',
                },
            },
            {
                type: 'password',
                name: 'password',
                label: 'パスワード',
                rules: {
                    required: '必須項目です。',
                },
            },
        ];

        const formConfig: ValidatoinFormConfig = {
            fields: fields,
            submitButtonText: 'ログイン',
            enableSubmitButton: true,
            enableCancelButton: false,
            cancelButtonText: '',
            submitCallback: onSubmit,
        };
        
    return (
        <div className='login-form'>
            <FormProvider {...methods}>
                <ValidatoinForm config={formConfig}></ValidatoinForm>
                <div className='error'>{loginMessage}</div>
            </FormProvider>
        </div>
    );
}

export default LoginForm;